import { ReactElement } from 'react';
import ResetPasswordPage from './views';

const ResetPasswordRoute = (): ReactElement => (
  <ResetPasswordPage />
);

export default ResetPasswordRoute;
